import { BaseStore, getOrCreateStore } from '../../di'
import { action, computed, observable } from 'mobx'
import { compose, map, uniq } from 'ramda'

function makeUrl(fontFamily) {
  switch (fontFamily) {
    default:
      return '/_static/fonts.css'
  }
}

class ThemeStore extends BaseStore {
  @observable headerColor = 'rgb(0,0,0)'
  @observable usedFonts = ['Roboto']

  @computed
  get fontUrls() {
    return compose(map(makeUrl), uniq)(this.usedFonts)
  }

  @action
  setFonts(xs) {
    this.usedFonts = xs
  }

  setHeaderColor(color) {
    this.headerColor = color
  }

  @action
  reset() {
    this.usedFonts = ['Roboto']
    this.headerColor = 'rgb(0,0,0)'
  }
}

export default getOrCreateStore('ThemeStore', ThemeStore)
